import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Por qué es tan barato?',
  a: 'Porque este es un formato de entrada. Quiero filtrar a las masas que solo se entretienen de los buscadores reales que están listos para invertir. A este precio, no tienes excusa para no intentarlo. Además, sé que una vez que veas el poder del RMA, querrás trabajar conmigo en niveles más profundos.'
}, {
  q: '¿Es apto para cualquier nicho?',
  a: 'Sí. La identidad es el software madre. Da igual si vendes seguros, haces trading, tienes una agencia o eres un profesional independiente. Tu mente es la que genera el resultado en cualquier área.'
}, {
  q: '¿Cuánto tiempo necesito dedicarle?',
  a: 'El manual se lee en menos de 90 minutos. El protocolo RMA de 48 horas requiere tu atención plena, pero puedes hacerlo mientras sigues con tu vida diaria si aplicas las herramientas de interrupción.'
}, {
  q: "¿Qué pasa si ya he leído sobre 'Ley de Atracción'?",
  a: "Esto es lo opuesto a la ley de atracción pasiva. Esto es ingeniería de identidad activa. No estamos 'pidiendo' al universo; estamos 'comandando' nuestra biología para que se alinee con la realidad que deseamos."
}, {
  q: '¿El contenido está en español?',
  a: '100%. Todo el material ha sido diseñado pensando en la psicología y el contexto cultural del emprendedor hispano.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-[80px] px-4" data-id="element-38">
      <div className="max-w-[800px] mx-auto" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-40">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-gold uppercase" data-id="element-41">
            <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-42"></span>
            Preguntas Frecuentes
          </div>
          <h2 className="font-heading text-3xl md:text-[40px] font-black leading-[1.1] text-white uppercase tracking-tight" data-id="element-43">
            RESPUESTAS PARA TU{' '}
            <span className="text-gold" data-id="element-44">MENTE ANALÍTICA</span>
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-45">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className={`overflow-hidden rounded-lg border transition-colors duration-300 ${isOpen ? 'border-gold bg-surface-dark' : 'border-border bg-surface'}`} data-id="element-46">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between px-[22px] py-[18px] text-left focus:outline-none" data-id="element-47">
                  <span className={`font-heading text-[13px] font-black tracking-[1px] uppercase transition-colors duration-300 ${isOpen ? 'text-gold' : 'text-white'}`} data-id="element-48">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${isOpen ? 'rotate-180 text-gold' : 'text-[#666]'}`} data-id="element-49" />
                </button>
                <AnimatePresence data-id="element-50">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-51">
                      <div className="px-[22px] pb-[22px] text-[13px] leading-[1.75] text-text-card border-t border-border pt-4" data-id="element-52">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}